export const play_store_random_games_tr = {
  randomTwoGame: "Rastgele İki Oyun",
  release_date: "Yayın Tarihi",
  last_release_date: "Son Yayın Tarihi"
};
